import { combineReducers } from 'redux'

function auth1 (state = {}, payload) {
  switch (payload.type) {
    case 'TOGGLE_AUTH':
      return {
        ...state,
        isAuthenticated: payload.value
      }
    default:
      return state
  }
}

function auth2 (state = {}, payload) {
  switch (payload.type) {
    case 'EXPERIMENT':
      return state
    default:
      return state
  }
}

const auth = combineReducers({ auth1, auth2 })

function user (state = {}, payload) {
  return state
}

export { auth, user }



// WEBPACK FOOTER //
// ./src/redux/index.js